import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ products }) => {
  // const currentProducts = products && products.slice(
  //   indexOfFirstProduct,
  //   indexOfLastProduct
  // ); this was the line that was gving me this red screen error so i commented this and wrot ethe below code instaed

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 lg:gap-10 auto-rows-[1fr] py-5 p-5 flex-4 max-w-[1500px] mx-auto">
      {products &&
        products?.length > 0 &&
        products?.map((product) => (
          // <div item key={product.id} >
          <ProductCard product={product} />
          // </div>
        ))}
    </div>
  );
};

export default ProductGrid;
